// extracted by mini-css-extract-plugin
module.exports = {"resetPassword-page":"styles_resetPassword-page__1wJKF"};